import { useEffect, useState } from 'react';
import { api, send } from './api.js';
import { t } from './i18n.js';
import { Notice } from './components.js';
export function TeamOrganizer({
  calendarId,
  event,
  onChange,
}: {
  calendarId: string;
  event: any;
  onChange: () => Promise<unknown>;
}) {
  const [info, setInfo] = useState<any>(),
    [person, setPerson] = useState(''),
    [error, setError] = useState(''),
    [busy, setBusy] = useState(false),
    [confirm, setConfirm] = useState(false);
  const url = `/team-calendars/${calendarId}/events/${event.id}/organizer`;
  const load = () =>
    api(url)
      .then(setInfo)
      .catch((e) => setError(e.message));
  useEffect(() => {
    setInfo(undefined);
    setPerson('');
    setConfirm(false);
    if (event.organizerId) void load();
  }, [calendarId, event.id, event.revision]);
  const act = async (action: string, userId: string, enabled?: boolean) => {
    setBusy(true);
    setError('');
    try {
      await send(url, { action, userId, enabled, revision: info.revision }, 'PUT');
      setConfirm(false);
      await load();
      await onChange();
    } catch (e: any) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  if (!event.organizerId) return null;
  return (
    <section className="pro-organizer">
      <h4>{t('Organisation et délégation')}</h4>
      <Notice>{error}</Notice>
      {info && (
        <>
          <p>
            {t('Organisateur')} : {info.organizer?.name} ({info.organizer?.email})
          </p>
          <p>
            {t(
              'Les délégués peuvent modifier et annuler les invitations au nom de l’organisateur.',
            )}
          </p>
          {info.delegates.map((id: string) => (
            <p key={id}>
              {info.people.find((p: any) => p.id === id)?.name ?? t('Ancien délégué')}
              {info.canDelegate && (
                <button disabled={busy} onClick={() => void act('delegate', id, false)}>
                  {t('Retirer la délégation')}
                </button>
              )}
            </p>
          ))}
          {(info.canDelegate || info.canTransfer) && (
            <>
              <label>
                {t('Personne autorisée')}
                <select
                  value={person}
                  onChange={(e) => {
                    setPerson(e.target.value);
                    setConfirm(false);
                  }}
                >
                  <option value="">{t('Choisir une personne')}</option>
                  {info.people
                    .filter((p: any) => p.id !== info.organizer.id)
                    .map((p: any) => (
                      <option key={p.id} value={p.id}>
                        {p.name} — {p.email}
                      </option>
                    ))}
                </select>
              </label>
              {info.canDelegate && (
                <button
                  disabled={busy || !person}
                  onClick={() => void act('delegate', person, true)}
                >
                  {t('Ajouter un délégué')}
                </button>
              )}
              {info.canTransfer && (
                <button disabled={busy || !person} onClick={() => setConfirm(true)}>
                  {t('Transférer l’organisation')}
                </button>
              )}
              {confirm && (
                <div className="notice">
                  <p>
                    {t(
                      'Le transfert annule les anciennes invitations et envoie une nouvelle invitation depuis le nouveau compte. Les invités devront répondre à nouveau.',
                    )}
                  </p>
                  <button disabled={busy} onClick={() => void act('transfer', person)}>
                    {t('Confirmer le transfert et inviter')}
                  </button>
                  <button disabled={busy} onClick={() => setConfirm(false)}>
                    {t('Retour')}
                  </button>
                </div>
              )}
            </>
          )}
        </>
      )}
    </section>
  );
}
